import { FUEL_TYPE_ELECTRICITY, FUEL_TYPE_GAS } from '../config/AppConfigurator';
import { useNavigate } from "react-router-dom";

export const QuerySelectionFactory = (fuelType) => {
    /* Using Factory Pattern to switch between the containers on the basis of fuel type selected */
    const navigate  = useNavigate();

      switch(fuelType){
        case FUEL_TYPE_ELECTRICITY:
          navigate('/meter-data-enquiry-method-selection', { state: { fuelType: FUEL_TYPE_ELECTRICITY } });
          break;
        case FUEL_TYPE_GAS:
          navigate('/meter-data-enquiry-method-selection', { state: { fuelType: FUEL_TYPE_GAS } });
          break;
        default:
          navigate('/');
      }
  };

export const isEmpty = (obj)=> {
    return Object.keys(obj).length === 0;
}

export const createAddressString = (addressLine1, addressLine2, city, postcode)=> {
    return addressLine1 && addressLine2 && city && postcode && `${addressLine1}, ${addressLine2}, ${city}, ${postcode}`
}